<template>
  <v-main
    id="pages"
    :class="$vuetify.theme.dark ? undefined : 'grey lighten-3'"
  >
    <v-img
      :class="{
        'v-image--sm': this.$vuetify.breakpoint.smAndDown,
        'v-image--md': this.$vuetify.breakpoint.mdAndDown
      }"
      :src="require(`@/assets/${src}`)"
      gradient="to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)"
      min-height="100%"
    >
      <v-responsive
        :style="styles"
        min-height="100vh"
        class="d-flex align-center"
      >
        <router-view />
      </v-responsive>
    </v-img>
  </v-main>
</template>

<script>
  export default {
    name: 'PagesCoreView',

    data: () => ({
      srcs: {
        '/about': 'pink-bokeh.jpg',
        '/': 'yellow-bokeh.jpg',
      },
    }),

    computed: {
      src () {
        var src = this.srcs[this.$route.path];
        if (!src) {
          src = this.srcs['/']
        }
        return src;
      },
      styles () {
        const paddingTop = this.$vuetify.breakpoint.mdAndUp ? 150 : 100
        const paddingBottom = this.$vuetify.breakpoint.mdAndUp ? 150 : 100
        return {
          padding: `${paddingTop}px 0 ${paddingBottom}px 0`,
        }
      },
    },
  }
</script>
